// Indicates the number of months to request for
export type TScenarioPeriodType = 'all' | number;

export const SCENARIO_PERIOD_ALL: TScenarioPeriodType = 'all';
